import { lazy } from "react";
import { Route } from "react-router-dom";

const FinancialsOverview = lazy(() => import("../../containers/financials/Overview"));
const NewInvoice = lazy(() => import("../../containers/financials/documents/invoices/New"));
const UpdateInvoice = lazy(() => import("../../containers/financials/documents/invoices/UpdateRoot"));
const DocumentComponentSelector = lazy(() => import("../../containers/financials/documents/invoices/DocumentComponentSelector"));
const RefundInvoice = lazy(() => import("../../containers/financials/documents/invoices/refund-invoice-document/RefundInvoice"));

export default function Key41Routes(key: string, link: string, identityServerUrl: string) {
	const key41Routes = [
		{ link: link + "/:tab", component: (props: any) => <FinancialsOverview {...props} /> },
		{ link: link + "/", component: (props: any) => <FinancialsOverview {...props} /> },
		{ link: link + "/documents/selector/:invoiceId", component: (props: any) => <DocumentComponentSelector {...props} /> },
		{ link: link + "/documents/new/:invoiceId", component: (props: any) => <NewInvoice {...props} /> },
		{
			link: link + "/documents/review/:invoiceId",
			component: (props: any) => <UpdateInvoice identityServerUrl={identityServerUrl} {...props} />,
		},
		{ link: link + "/documents/issued/:invoiceId", component: (props: any) => <UpdateInvoice {...props} /> },
		{ link: link + "/documents/settled/:invoiceId", component: (props: any) => <UpdateInvoice {...props} /> },
		{ link: link + "/documents/invoice/print/:invoiceId", component: (props: any) => <RefundInvoice {...props} /> },
	];

	return key41Routes.map((r, i) => <Route exact key={i} path={r.link} render={r.component} />);
}
